/**
 * redshift模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const redshift = {
  //分页
  pageRedshift(params) {
    return $http.post(`${global.API_URL}/sme/redshift/page`,params);
  },
  //查询当前用户下所有Redshift
  queryRedshiftByAccount(params) {
    return $http.post(`${global.API_URL}/sme/redshift/queryRedshiftByAccount`,params);
  },
  //根据name查询redshift
  queryRedshiftByRedshiftId(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/redshift/queryRedshiftByRedshiftId`,param);
  },
  //删除
  deleteRedshift(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/redshift/delete`,param);
  }
}

export default redshift;



// WEBPACK FOOTER //
// ./src/api/redshift.js